import React, { useEffect, useState } from "react";
import {
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import Pagination from "../../../../Components/Utils/Pagenation";
import CustomDataTable from "../../../../Components/Others/CustomDataTable";
import {  useLocation, useParams } from "react-router-dom";
import axiosInstance from "../../../../Services/axiosCommon";
import * as yup from "yup";
import UseGetDataSearchByProUser from "../../../../Components/Hooks/useFetchDataByPROUser";
import { useFormik } from "formik";
import ClientManagementLayout from "../ClientManagementLayout";
import { GetAccess, GetNotUseRole } from "../../../../Components/Utils/roles";
import { NuDate } from "../../../../Components/Utils/Input";
import NuDateFormate, { formatDate }  from "../../../../Components/Utils/NuDate";
import MobileeCRIndex from "../../../Mobile/ClientManage/Contract/MobileeCRIndex";

import CloseIcon from "../../../../Components/Icons/Close";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import ContractManagementLayout from "../contractManagementLayout";
import ImportFileModal from "../../../../Components/Utils/ImportFileComponent";
import MultiEdiQuotes from "./MultiEditQuotes";
import QuotationLayout from "../QuotationLayout";
import MobileQuotationIndex from "../../../Mobile/Quotation/MobileQuotationIndex";
import UseDropDownAP from "../../../../Components/Hooks/UseApprovalDD";





function QuotesIndex() {
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
      });
    
      useEffect(() => {
        const handleResize = () => {
          setScreenSize({
            width: window.innerWidth,
          });
        };
    
        window.addEventListener("resize", handleResize);
    
        return () => {
          window.removeEventListener("resize", handleResize);
        };
      }, []);

  const [open, setOpen] = useState(false);
  const location = useLocation();
  const state = location.state;
  const { officeId } = useParams();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20
  );
  
  const [filter, setFilter] = useState(state?.approvalStatus  ||state?.industry ? true : false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [showExport, setShowExport] = useState(false);

  const {value:status} = useFetchMDIndex
  (`/dropdown/dropdown-details/`,'Status_Contracts', [showFilterDialog, showExport],
    () => showFilterDialog || showExport)

      const {value:paymentTerms ,getData:refpaymentTerms} = useFetchMDIndex(`/dropdown/dropdown-details/`,'paymentTerms')
    const { value: DeliveryTerms, getData: refDeliveryTerms } = useFetchMDIndex(
         `/dropdown/dropdown-details/`,
         "Delivery_Terms_Contractor",[showFilterDialog, showExport],
    () => showFilterDialog || showExport
       );
    
       const { value: Validity, getData: refValidity } = useFetchMDIndex(
         `/dropdown/dropdown-details/`,
         "validity_quotes",[showFilterDialog, showExport],
    () => showFilterDialog || showExport
       );

       const { data: ApprovalStatus, getData: getApprovalStatus } = UseDropDownAP(
    "/approval-status/drop-down/by-module/quotation",[showFilterDialog, showExport],
    () => showFilterDialog || showExport
  );
  // const { value: inspectionType,getData:refinspectionType } = useFetchMDIndex(
  //   `/dropdown/dropdown-details/`,
  //   "Inspection_Type_Contracts",showFilterDialog
  // ); 
  const [filterProps, setFilterProps] = useState({
    status:"",
validity:"",
deliverTerms:"",
paymentTerms:"",
approvalStatus:"",
fromDate:"",
toDate:"",
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
   status:"",
validity:"",
deliverTerms:"",
paymentTerms:"",
    approvalStatus:state?.approvalStatus? state.approvalStatus :"",

fromDate:"",
toDate:"",
  });
  const clearFilter = () => {
    setParams({
      ...params,
   status:"",
validity:"",
deliverTerms:"",
paymentTerms:"",
approvalStatus:"",
fromDate:"",
toDate:"",
    });
    formik.values.status = "";
    formik.values.validity = "";
    formik.values.deliverTerms = "";
    formik.values.paymentTerms = "";
    formik.values.fromDate = "";
    formik.values.toDate = "";
    formik.values.approvalStatus = "";

    setFilter(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
  await new Promise((resolve) => setTimeout(resolve, 300)); // give Formik time to set isSubmitting

      console.log("ffff", value);
      setParams({ ...params,
         status: value.status, 
         approvalStatus: value.approvalStatus, 
         validity: value.validity, 
         deliverTerms: value.deliverTerms, 
         paymentTerms: value.paymentTerms, 
         fromDate: value.fromDate, 
         toDate: value.toDate, 

        });
      closeFilterDialog();
      setFilter(true);
      setFilterProps({
        status:"",
validity:"",
deliverTerms:"",
paymentTerms:"",
approvalStatus:"",
fromDate:"",
toDate:"",
      });
    },
  });
  // const { data,totalCount, getData, dataLoading } = UseGetDataSearch(
  //   `/contract/listing`,
  //   params,
  //   'contract'
  // );
  const { data,totalCount, getData, dataLoading } = UseGetDataSearch(
    `/quotation/listing`,
    params,
    
  );
  const [viewMode, setViewMode] = useState(
    localStorage.getItem("viewMode") || "card"
  );

    function getView() {
    axiosInstance 
      .get(`/approval-status/drop-down/by-module/quotation`)
      .then((res) => {
        console.log(res.data?.data,"approve");    
        // setisSubmited(res.data?.data?.isSubmited === true);       

      })
      .catch(err=>{
        console.log("err", err);
      })
  }

    useEffect(() => {
      // if (!cdata) {
        getView();
      // }
    }, [])
console.log();


  const defaultHeader = [
    {
      title: "Ref.",
      width: "12.87%",
      isLink: true,
      id: "id",
      link: `/quotation/quote/view/`,
      field: "refNumber",
      textAlign: "left",
      rowAlign: "left",
    },
    GetNotUseRole("client") ? {
      title: "Client",
      width: "12.87%",
      isLink: true,
      id: "id",
      link: `/quotation/quote/view/`,
      field: "clientName",
      textAlign: "left",
      rowAlign: "left",
    }:
    {
      title: " ",
      width: "0.1%",
      field: " ",
      textAlign: "left",
      rowAlign: "left",
    },

    // {
    //   title: "Date ",
    //   width: "10%",
    //   field: "date",
    //   type: "date",
    //   textAlign: "left",
    //   rowAlign: "left",
    // },
    {
      title: "Total Price ",
      width: "12.87%",
      field: "totalPrice",
      textAlign: "left",
      rowAlign: "left",
      type: "text",
      type:"amount",

    },

    {
      title: "Date ",
      width: "12.87%",
      field: "date",
      textAlign: "left",
      rowAlign: "left",
      type: "date",
    },
    {
      title: "Validity",
      width: "12.87%",
      field: "validity",
      textAlign: "left",
      rowAlign: "left",
    },
    // {
    //   title: "Delivery Terms ",
    //   width: "12.87%",
    //   field: "deliveryTerms",
    //   textAlign: "left",
    //   rowAlign: "left",
    // },
    // {
    //   title: "Payment Term ",
    //   width: "12.87%",
    //   field: "paymentTerms",
    //   textAlign: "left",
    //   rowAlign: "left",
    // },


    {
      title: "Status ",
      width: "12.87%",
      field: "status",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "Action",
      width: "10%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "id",
        removeValue: "clientName",
        url: `/quotation/`,
        moduleName: "Quotes",
        from: `/quotation/quote`,
        editLink: `/quotation/quote/edit/`,
        viewLink: `/quotation/quote/view/`,
      },
    },
  ];
  const availableHeaders = [
    {
      title: "ID",
      width: "5%",
      field: "id",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Client",
      width: "10%",
      isLink: true,
      id: "id",
      link: `/quotation/quotes/view/`,
      field: "client",
      textAlign: "center",
      rowAlign: "center",
    },
  ];
  useEffect(() => {
    localStorage.setItem("viewMode", viewMode);
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount, viewMode]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };
  const [exportValue, setExportValue] = useState({
  status:"",
validity:"",
deliverTerms:"",
paymentTerms:"",
approvalStatus:"",
fromDate:"",
toDate:"",
  });
  const ExportFormik = useFormik({
  enableReinitialize: true,
  initialValues: exportValue,
  validateOnChange: false,
  validateOnBlur: false,
  onSubmit: async (value, { resetForm, setSubmitting }) => {
    try {
      const response = await axiosInstance.get(
        `/quotation/export?fromDate=${value.fromDate}&toDate=${value.toDate}&status=${value.status}&approvalStatus=${value.approvalStatus}&paymentTerms=${value.paymentTerms}&deliverTerms=${value.deliverTerms}&validity=${value.validity}`,
        { responseType: "blob" }
      );

      const pdfBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `Quotation Report ${formatDate(new Date())}.xlsx`;

      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading the Excel:", error);
    } finally {
      setSubmitting(false); // ✅ ensure spinner stops
    }
  },
});

  const closeFilterDialogebox = () => {
    setShowExport(false);
  };

  const [showEdit, setShowEdit] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const selectOneFunction = (value) => {

    let NewId;
    if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
      NewId = listofNumbers.filter((Temp) => Temp !== value);
      setListofNumbers(NewId);
    } else {
      setListofNumbers([...listofNumbers, value]);
    }
  };

  const selectMultipleFunction = (e) => {
    if (e.target.checked) {
      setListofNumbers(fullList);
    } else {
      setListofNumbers([]);
    }
  };

  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        tempArr.push(i?.id);
      });
    setFullList(tempArr);
  }, [data]);

  const [valueOfSearch,setValuesofSearch] = useState("")
  function searchFunction(e) {

    
    setValuesofSearch(e?.target?.value)
    setParams({ ...params, search: e?.target?.value, page:1 });
    setPage(1)
  }

  
  return (
    <>
<QuotationLayout 
      setOpen={setShowImportModal}
      searchFun={searchFunction}

        getData={getData}
        isCard={false}
        isFilter={filter}
         newfilter={true}
        setFilterOpen={setShowFilterDialog}
        ClearFilter={clearFilter}
        CreateAccess={GetAccess("quotes_create")}
        // ImportAccess={GetAccess("quotes_import")}
        ExportAccess={GetAccess("quotes_export")}
        officeId={officeId}
        searchValue={valueOfSearch}
        setViewMode={setViewMode}
        neededSearch={true}
        viewMode={viewMode}
        setOpenExport={setShowExport}
        // handleSearch={handleSearch}
      total={totalCount}

        >
              {
  screenSize.width <= "786" ?(<>
  <div className=' w-full h-[calc(100vh-205px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
  <MobileQuotationIndex
  data={data}
  total={totalCount}
  pageIndex={page}
  setPageIndex={setPage}
  dataCount={pageCount}
  setDataCount={setPageCount}
  officeId={officeId}
  getData={getData}

  />
  </div>
  </>):(<>
    <div className="w-full h-full ">
      
      {/* {viewMode === "list" ? ( */}
        <CustomDataTable
          fetcher={getData}
          data={data}
          availableHeaders={availableHeaders}
          defaultHeader={defaultHeader}
          bodyHeight="max-h-[calc(100vh-260px)]"
          height="h-[calc(100vh-160px)]"
          total={totalCount}
        title='Quotes'

          pageIndex={params.page}
          setPageIndex={setPage}
          dataCount={params.per_page}
          setDataCount={setPageCount}
          storageName="QuotesTable"
            editAccess="quotes_edit"
          deteleAccess="quotes_delete"
          dataLoading={dataLoading}
          searchQuery={params?.search != "" ? params?.search : ""}
          hasMultiEdit={true}
          selectOneFunction={selectOneFunction}
          setShowEdit={setShowEdit}
          showEdit={showEdit}
          listofNumbers={listofNumbers}
          selectMultipleFunction={selectMultipleFunction}
          fullList={fullList}
          getById="id"
        />
      {/* ) : (
        <>
          <div className="w-full h-[calc(100vh-190px)] rounded-md bg-white p-3 mt-4 relative overflow-y-scroll">
            <div className="flex gap-40">
              <p className="text-xs font-semibold text-[#111537] text-left">
                Survey Report : {totalCount}
              </p>
            </div>
            <div className="w-full flex justify-start flex-wrap md:gap-x-5 lg:gap-x-6 gap-y-6 pt-4">
              {dummyData &&
                dummyData.map((item, idx) => (
                  <SurveyReportCard fetcher={getData} item={item} key={idx} />
                ))}
            </div>
          </div>
          <div className="w-full h-[40px] rounded-b-md bg-white">
            <Pagination
              total={totalCount}
              pageIndex={page}
              setPageIndex={setPage}
              dataCount={pageCount}
              setDataCount={setPageCount}
            />
          </div>
        </>
      )} */}
      </div>
      </>)}
      </QuotationLayout>
     
      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter </h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="sm:flex flex-col mb-4">
              {/* <p className="py-2 px-6 text-m">Date</p>
              <div className="sm:flex justify-between  w-full ">
               <NuDate
                label="From "
                placeholder="dd/mm/yyyy"
                formik={formik}
                name="dateFrom"
                width="w-full"
              />
               <NuDate
                label="To "
                placeholder="dd/mm/yyyy"
                formik={formik}
                name="dateTo"
                width="w-full"
              />
              </div> */}
              {/* <p className="py-2 px-6 text-m">Start Date</p> */}
              <div className="sm:flex justify-between  w-full ">
               <NuDate
                label="From "
                placeholder="dd/mm/yyyy"
                formik={formik}
                name="fromDate"
                width="w-full"
              />
               <NuDate
                label="To "
                placeholder="dd/mm/yyyy"
                formik={formik}
                name="toDate"
                width="w-full"
              />
              </div>
              {/* <p className="py-2 px-6 text-m">End Date</p> */}
              {/* <div className="sm:flex justify-between  w-full ">
               <NuDate
                label="From "
                placeholder="dd/mm/yyyy"
                formik={formik}
                name="endDateFrom"
                width="w-full"
              />
               <NuDate
                label="To "
                placeholder="dd/mm/yyyy"
                formik={formik}
                name="endDateTo"
                width="w-full"
              />
              </div> */}
              {/* <p className="py-2 px-6 text-m">Renewal Date</p>
              <div className="sm:flex justify-between  w-full ">
               <NuDate
                label="From "
                placeholder="dd/mm/yyyy"
                formik={formik}
                name="renewalDateFrom,
"
                width="w-full"
              />
               <NuDate
                label="To "
                placeholder="dd/mm/yyyy"
                formik={formik}
                name="renewalDateTo"
                width="w-full"
              />
              </div> */}

                <FormikSelectTwo
                                        label="Validity"
                                        Options={Validity}
                                        formik={formik}
                                        placeholder="Choose"
                                        name="validity"
                                        width="w-full "
                                          FixPosition={true}
                                                PortalTarget={false}
                                                     displayProperty={"Validity"}
                               propertyName={"validity_quotes"}
                                                
                                      />

                                       <FormikSelectTwo
                             label="Delivery Terms"
                             placeholder="Choose"
                             Options={DeliveryTerms}
                             formik={formik}
                             name="deliverTerms"
                             width="w-full"
                             getFunc={refDeliveryTerms}
                             displayProperty={"Delivery Terms"}
                             propertyName={"Delivery_Terms_Contractor"}
                           />
            
                         <FormikSelectTwo
                                        label="Payment Terms"
                                        placeholder="Choose"
                                        Options={paymentTerms}
                                        formik={formik}
                                        name="paymentTerms"
                                        width="w-full"
                                        getFunc={refpaymentTerms}
                                        displayProperty={"Payment Terms"}
                                        propertyName={"paymentTerms"}
                                          FixPosition={true}
                                  PortalTarget={false}
                                      />

                                        <FormikSelectTwo
              type="text"
              label="Approval Status"
              placeholder="Approval Status"
              Options={ApprovalStatus}
              formik={formik}
              name="approvalStatus"
              width="w-full "
            />

                             <FormikSelectTwo
                                           label="Status"
                                           Options={status}
                                           formik={formik}
                                           placeholder="Choose"
                                           name="status"
                                          
                                           width="w-full "
                                         />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                           <SubmitButton name="Apply" isLoading={formik.isSubmitting} />
                
              </div>
            </form>
          </div>
        </div>
      )}

      {showEdit && (
        <MultiEdiQuotes
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      {showImportModal && (
        <ImportFileModal
          show={showImportModal}
          onClose={closeModal}
        apiUrl="/clients/import"
        menuName="Client"
        getData={getData}
        />
        
      )}
      {showExport && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                <div className="animate-scale-in min-w-[85%] sm:min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                  <div className=" w-full flex justify-between items-center  bg-white">
                    <h2 className=" text-sm 2xl:text-base font-medium ">
                      Export Data
                    </h2>
                    <div
                      className=" cursor-pointer "
                      onClick={() => setShowExport(false)}
                    >
                      <CloseIcon />
                    </div>
                  </div>
                  <form onSubmit={ExportFormik.handleSubmit}>
                    <div className=" w-full flex flex-wrap">
                      <div className=" w-full flex ">
                        <div className=" w-1/2 flex items-center px-6 py-3 ">
                          <input
                            id="default-radio-1"
                            type="radio"
                            value="all"
                            name="type"
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                            onChange={ExportFormik.handleChange}
                            checked={ExportFormik.values.type =="all"}
                          />
                          <label
                            htmlFor="default-radio-1"
                            className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                          >
                            All Data
                          </label>
                        </div>
      
                        <div className="w-1/2 flex items-center px-6 py-3">
                          <input
                            id="default-radio-2"
                            type="radio"
                            value="filter"
                            name="type"
                            className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                            onChange={ExportFormik.handleChange}
                            checked={ExportFormik.values.type == "filter"}
                          />
                          <label
                            htmlFor="default-radio-2"
                            className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                          >
                            Filter Data
                          </label>
                        </div>
                      </div>
                      {ExportFormik.values.type === "filter" && (
                        <>
                     <div className="sm:flex justify-between  w-full ">
               <NuDate
                label="From "
                placeholder="dd/mm/yyyy"
                formik={ExportFormik}
                name="fromDate"
                width="w-full"
              />
               <NuDate
                label="To "
                placeholder="dd/mm/yyyy"
                formik={ExportFormik}
                name="toDate"
                width="w-full"
              />
              </div>
                <FormikSelectTwo
                                        label="Validity"
                                        Options={Validity}
                                        formik={ExportFormik}
                                        placeholder="Choose"
                                        name="validity"
                                        width="w-full md:w-1/2"
                                          FixPosition={true}
                                                PortalTarget={false}
                                                     displayProperty={"Validity"}
                               propertyName={"validity_quotes"}
                                                
                                      />

                                       <FormikSelectTwo
                             label="Delivery Terms"
                             placeholder="Choose"
                             Options={DeliveryTerms}
                             formik={ExportFormik}
                             name="deliverTerms"
                             width="w-full md:w-1/2 lg:w-1/2"
                             getFunc={refDeliveryTerms}
                             displayProperty={"Delivery Terms"}
                             propertyName={"Delivery_Terms_Contractor"}
                           />
            
                         <FormikSelectTwo
                                        label="Payment Terms"
                                        placeholder="Choose"
                                        Options={paymentTerms}
                                        formik={ExportFormik}
                                        name="paymentTerms"
                                        width="w-full md:w-1/2 lg:w-1/2 "
                                        getFunc={refpaymentTerms}
                                        displayProperty={"Payment Terms"}
                                        propertyName={"paymentTerms"}
                                          FixPosition={true}
                                  PortalTarget={false}
                                      />
  <FormikSelectTwo
              type="text"
              label="Approval Status"
              placeholder="Approval Status"
              Options={ApprovalStatus}
              formik={ExportFormik}
              name="approvalStatus"
              width="w-full md:w-1/2 lg:w-1/2"
            />
                             <FormikSelectTwo
                                           label="Status"
                                           Options={status}
                                           formik={ExportFormik}
                                           placeholder="Choose"
                                           name="status"
                                          
                                           width="w-full md:w-1/2 lg:w-1/2 "
                                         />
             
                        </>
                      )}
                      <div className="flex w-full justify-end gap-2">
                        <CancelButton handleClick={closeFilterDialogebox} />
                                          <SubmitButton name="Export" isLoading={ExportFormik.isSubmitting} />
                       
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            )}
    
    </>
  );
}
export default QuotesIndex;